import { makeApiRequests } from '../helpers/api';
import { ENDPOINTS } from '../helpers/constants';

export const apartmentServices = {
  getApartments: async (requestBody, signal) => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.GET_APPARTMENTS,
      requestBody: requestBody,
      signal: signal,
      method: 'POST'
    });

    return { response, error };
  },
  createApartment: async requestBody => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.CREATE_APARTMENT,
      requestBody: requestBody,
      method: 'POST'
    });

    return { response, error };
  },
  updateApartment: async (id, requestBody) => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.APARTMENT_WITH_ID(id),
      requestBody: requestBody,
      method: 'PUT'
    });

    return { response, error };
  },
  deleteApartment: async id => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.APARTMENT_WITH_ID(id),
      method: 'DELETE'
    });

    return { response, error };
  },
  createDriveFolder: async requestBody => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.CREATE_DRIVE_FOLDER,
      requestBody: requestBody,
      method: 'POST'
    });

    return { response, error };
  },
  createMeeting: async apartmentId => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.CREATE_MEETING(apartmentId),
      method: 'POST'
    });

    return { response, error };
  },
  updateApartmentNotes: async (id, requestBody) => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.UPDATE_APARTMENT_NOTES(id),
      method: 'PUT',
      requestBody: requestBody
    });

    return { response, error };
  },

  updateMultipleApartments: async requestBody => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.UPDATE_MULTIPLE_APARTMENTS,
      requestBody: requestBody,
      method: 'PUT'
    });

    return { response, error };
  },
  getApartmentChangeLogs: async id => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.APARTMENT_CHANGE_LOGS(id),
      method: 'GET'
    });

    return { response, error };
  },
  duplicateApartment: async id => {
    const { response, error } = await makeApiRequests({
      endpoint: ENDPOINTS.APARTMENT_WITH_ID(id),
      requestBody: {},
      method: 'POST'
    });

    return { response, error };
  }
};
